export default __webpack_public_path__ + "static/media/about.d1a2f155.jpg";